import { useTheme } from "@mui/material";
import AccentSuccess from "../../../icons/AccentSuccess.svg?react";
import { OauthPopup } from "./OauthPopup";

const OauthSuccess = () => {
  const theme = useTheme();
  return (
    <OauthPopup
      Icon={
        <AccentSuccess
          width="54px"
          height="54px"
          color={theme.palette.text10.main}
          fill={theme.palette.accentSuccess30.main}
        />
      }
      outcome="Authentication completed."
      oauthId="oauth-success"
    />
  );
};

export { OauthSuccess };
